import { inject, Pipe, PipeTransform } from '@angular/core';
import { generateColorFromString } from '../../site-pages/secure-pages/main-dashboard/utils/comman';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { backgroundColor } from './constant/color-code';

@Pipe({
  name: 'highlightText',
  standalone: true
})
export class HighlightTextPipe implements PipeTransform {
  sanitizer = inject(DomSanitizer);

  transform(
    value: string | null | undefined,
    matchingStrings?: string[],
    ...args: unknown[]
  ): SafeHtml {
    if (!value) return '';
    let text = value as string;
    const hashtagRegex = /#\w+/g; // Matches hashtags
    value = value.replace(hashtagRegex, (match) => {
      return `<span style="color: darkblue">${match}</span>`;
    });

    const quotedTextRegex = /"([^"]+)"/g; // Matches text within quotes
    value = value.replace(quotedTextRegex, (match) => {
      if (!matchingStrings.includes(match.replaceAll('"', ''))) return match;
      const background =
        backgroundColor[match.replaceAll('"', '').toLowerCase()] ||
        generateColorFromString(match);
      return `<span style='background-color: ${background}; padding: 2px;
    border-radius: 2px;'>${match.replaceAll(
        '"',
        ''
      )}</span>`;
    });

    return this.sanitizer.bypassSecurityTrustHtml(value);
  }
}
